import { useOrganizationData } from '@/features/organizations/organization.hooks';
import Combobox, {
  ComboboxItem,
} from '@oncolens/oncolens-ui/lib/components/FormControls/Combobox/Combobox';
import useDebounce from '@oncolens/oncolens-ui/lib/hooks/common/useDebounce';
import React, { useState } from 'react';

interface Props {
  setSelectedOrgs: React.Dispatch<React.SetStateAction<ComboboxItem[]>>;
}

export default function TableOrgFilter({ setSelectedOrgs }: Props) {
  const orgData = useOrganizationData();
  const [inputValue, setInputValue] = useState<ComboboxItem[]>([]);
  const debouncedSearch = useDebounce((value: any) => setSelectedOrgs(value), 500);

  return (
    <div className="w-1/3 ml-auto">
      <Combobox
        id={'organization-filter'}
        htmlName={'organization-filter'}
        label={'Organization Filter'}
        value={inputValue as any}
        onChange={(data) => {
          if (Array.isArray(data) || !data) {
            setInputValue(data);
            debouncedSearch(data);
          }
        }}
        data={orgData || []}
        useAutocomplete
        useMultipleSelect
        useSrOnlyLabel
        placeholder="Filter by organization"
      />
    </div>
  );
}
